<script setup lang="ts">
type Props = {
  weight?: string | number
  measure?: string
  volumeInLiters?: number
}

const props = defineProps<Props>()

const measureValue = computed(() => {
  if (props.volumeInLiters) {
    return `${formatFloat(props.volumeInLiters)} л`
  }

  if (props.weight && props.measure) {
    return `${formatFloat(props.weight)} ${props.measure}`
  }

  return ''
})
</script>

<template>
  <span class="app-measure-units">{{ measureValue }}</span>
</template>

<style lang="scss" scoped>
.app-measure-units {
  white-space: nowrap;
}
</style>
